<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">New maternity period</h3>
  </div>

  <!---------- main content ---------->

  <div class="dialog-content__container">
    <form [formGroup]="maternityForm">
      <div class="maternity">
        <div class="row align-items-center index-z">
          <label
            class="label-input col-4"
            appMarkAsterisk
            [formGroup]="maternityForm"
            [controlName]="'startDate'"
            [touched]="maternityForm.get('startDate')!.touched"
            >Start date
          </label>
          <app-datepicker
            class="col-3"
            [iconLeft]="true"
            formControlName="startDate"
            [staticPropery]="true"
            (datepickerOpened)="isDatePickerOpened = $event"
          >
          </app-datepicker>
        </div>
        <div class="row align-items-center index-z">
          <label
            class="label-input col-4"
            appMarkAsterisk
            [formGroup]="maternityForm"
            [controlName]="'endDate'"
            [touched]="maternityForm.get('endDate')!.touched"
            >End date
          </label>
          <app-datepicker
            class="col-3"
            [iconLeft]="true"
            formControlName="endDate"
            [deadLine]="isoStartDate"
            [disabl]="!startDate.value"
            [staticPropery]="true"
            (datepickerOpened)="isDatePickerOpened = $event"
          >
          </app-datepicker>
        </div>
        <div
          class="row align-items-center index-z"
          *ngIf="maternityForm.get('vacationDecision')?.value"
        >
          <label
            class="label-input col-4"
            appMarkAsterisk
            [formGroup]="maternityForm"
            [controlName]="'paymentDate'"
            [touched]="maternityForm.get('paymentDate')!.touched"
            >Payment date
          </label>
          <app-datepicker
            class="col-3"
            [iconLeft]="true"
            [monthVisible]="true"
            formControlName="paymentDate"
            [staticPropery]="true"
            (datepickerOpened)="isDatePickerOpened = $event"
          >
          </app-datepicker>
        </div>
        <div class="row align-items-center">
          <label
            class="label-input col-4"
            appMarkAsterisk
            [formGroup]="maternityForm"
            [controlName]="'comment'"
            [touched]="maternityForm.get('comment')!.touched"
            >Comment</label
          >
          <div class="col-6 input__wrapper">
            <input
              type="text"
              class="input__basic"
              placeholder=" "
              formControlName="comment"
            />
            <app-error-field
              [displayError]="
                maternityForm.get('comment')!.hasError('wordCount')
              "
              [errorMessage]="'Max field length = 400 words'"
            ></app-error-field>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!--  save/cancel buttons -->
  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0">
      <button class="button button__save add-margin" (click)="save()">
        Save
      </button>
      <button class="button button__cancel" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
